import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Autocomplete,
} from "@mui/material";
import { useFormik } from "formik";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useGetAllSearchCompanyQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetLastWorkOrderIdQuery,
  useGetPriceHistoryQuery,
  useGetProductQuery,
  useGetTaxQuery,
  useGetWorkOrderQuery,
  useEditInvoiceMutation,

} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import {
  ICompanyDetails,
  ICustomer,
  ICustomerProject,
  IPriceHistoryPayload,
  IProductPopUP,
  ITaxes,
} from "../../../Api/Interface/api.interface";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../../Components/Validation/validationUtils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toDate } from "date-fns";
import dayjs, { Dayjs } from "dayjs";
import { normalizeDateTimeFields } from "../../../Core/utils/dateTime";
import {
  ProductType,
  TransferType,
  WorkOrderStatus,
} from "../../../Core/Enum/enum";
import AddIcon from "@mui/icons-material/Add";
import { FaTrash } from "react-icons/fa";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import NewCompanyPopUp from "../../CompanyInfo/Components/NewCompanyPopUp";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { useParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { FaEdit } from "react-icons/fa";
import { useGetAllInvoiceQuery } from "../../../Api/attoDeskApi";
import placeholderImage from '../../../Images/fav.png';
import { City } from "country-state-city";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const generateWorkOrderNumber = (workOrderId: number) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `WO${year}${month}${day}-${workOrderId.toString().padStart(2, "0")}`;
};

interface IProduct {
  productName: string;
  productDescription: string;
  productImg: String | null;
  numberOfPassengers: number | null;
  busCount: number | null;
  transferType: string;
  transferTypeFrom: string;
  transferTypeTo: string;
  transferTypeDescription: string;
  departureDateTime: Dayjs | null;
  returnDateTime: Dayjs | null;
  departureAddress: string;
  destinationAddress: string;
  multiDestination: string;
  quantity: number | null;
  price: number | null;
  tax: number;
  taxAmount: number;
  total: number;
  taxId: number | null;
  unitPriceWithDiscount: number | null;
  unitTotalWithDiscount: number;
  productType: string;
  productLongDescription: string;
  productShortDescription: string;
}

interface IDiscount {
  value: number | null;
  description: string;
}

interface IQuoteWorkOrder {
  id: number;
  po_number: string;
  quoteWorkOrderCompanyId: number;
  quoteWorkOrderCustomerId: string;
  quoteWorkOrderCustomerProjectId: string;
  quoteWorkOrderNo: string;
  quoteWorkOrderIssueDate: Dayjs;
  quoteWorkOrderDueDate: Dayjs;
  quoteWorkOrderAmount: number | null;
  quoteWorkOrderStatus: number;
  quoteWorkOrderSale: IProduct[];
  quoteWorkOrderDiscount: string;
  quoteWorkOrderSubTotal: string;
  quoteWorkOrderSaleGrandTotal: string;
  quoteWorkOrderSaleDiscountDescription: IDiscount[];
  customer: ICustomer;
  company: ICompanyDetails;
  project: ICustomerProject;
  quoteWorkOrderCustomerRemark: string;
  quoteWorkOrderCustomerMemo: string;
  quoteWorkOrderSaleDiscount: string;
  quoteWorkOrderSaleSubTotal: string;
  isInvoice: boolean;
  created_by: number;
  created_at: string;
  mainStatus: number;
  invoiceId: number;
  InvoiceNo: string;
 
}

interface IProductSub {
  productName: string;
  transferTypeTo: string;
  transferTypeFrom: string;
}

const Index: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const { id: QuoteId } = useParams<{ id: string }>();
  useEffect(() => {}, [QuoteId]);

  const {
    data: workOrderData,
    isLoading: workIsLoading,
    isError: workOrderError,
    refetch: workOrderRefetch,
  } = useGetAllInvoiceQuery({
    searchText: "",
    id: String(QuoteId),
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
  });

  const WorkOrderDataList = useMemo(() => {
    if (
      workOrderData &&
      Array.isArray(workOrderData.data) &&
      workOrderData.data.length > 0
    ) {
      return workOrderData.data[0] as IQuoteWorkOrder;
    }
    return null;
  }, [workOrderData]);


   useEffect(() => {
      // Fetch all cities in Canada (country code "CA")
      const cities = City.getCitiesOfCountry("CA");
      if (cities) {
        setCanadianCities(Array.from(new Set(cities.map((city) => city.name))).sort());
      }
    }, []);

  useEffect(() => {
    if (
      workOrderData &&
      Array.isArray(workOrderData.data) &&
      workOrderData.data.length > 0
    ) {
      const workOrder = workOrderData.data[0];
      const saleProducts = workOrder.quoteWorkOrderSale;

      const mappedProductRows = saleProducts.map((saleProduct: IProduct) => ({
        productName: saleProduct.productName,
        productDescription: saleProduct.productDescription,
        productImg: saleProduct.productImg,
        numberOfPassengers: saleProduct.numberOfPassengers,
        busCount: saleProduct.busCount,
        transferType: saleProduct.transferType,
        transferTypeFrom: saleProduct.transferTypeFrom,
        transferTypeTo: saleProduct.transferTypeTo,
        transferTypeDescription: saleProduct.transferTypeDescription || "",
        departureDateTime: dayjs(saleProduct?.departureDateTime) || null,
        returnDateTime: dayjs(saleProduct?.returnDateTime) || null,
        departureAddress: saleProduct.departureAddress || "",
        destinationAddress: saleProduct.destinationAddress || "",
        multiDestination: saleProduct.multiDestination || "",
        quantity: saleProduct.quantity,
        price: saleProduct.price,
        tax: saleProduct.tax || 0,
        taxAmount: saleProduct.taxAmount || 0,
        taxId: saleProduct.taxId || null,
        total: saleProduct.total,
        unitPriceWithDiscount: saleProduct.unitPriceWithDiscount,
        unitTotalWithDiscount: saleProduct.unitTotalWithDiscount,
        productType: saleProduct.productType,
        productLongDescription: saleProduct.productLongDescription || "",
        productShortDescription: saleProduct.productShortDescription || "",
      }));

      setProductRows(mappedProductRows);
    }
  }, [workOrderData]);

  useEffect(() => {
    console.log("WorkOrderDataList updated:", WorkOrderDataList);
  }, [WorkOrderDataList]);

  useEffect(() => {
    if (
      workOrderData &&
      Array.isArray(workOrderData.data) &&
      workOrderData.data.length > 0
    ) {
      const workOrder = workOrderData.data[0];
      const saleProducts = workOrder.quoteWorkOrderSaleDiscountDescription;

      const mappedProductRows = saleProducts.map((saleProduct: IDiscount) => ({
        value: saleProduct.value,
        description: saleProduct.description,
      }));

      setDiscounts(mappedProductRows);
    }
  }, [workOrderData]);

  const [newTax, { isLoading }] =  useEditInvoiceMutation();
  const { showErrorMessage, showMessage } = useNotifier();

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
  const debouncedSearchQueryCustomer = useDebounce(searchQueryCustomer, 300);
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);

  const [searchQueryProduct, setSearchQueryProduct] = useState<string>("");
  const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =
    useState<string>("");
  const debouncedSearchQueryProduct = useDebounce(searchQueryProduct, 300);
  const [showDropdownProductIndex, setShowDropdownProductIndex] = useState<
    number | null
  >(null);

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const [averagePrice, setAveragePrice] = useState<number | null>(null);
  const [nextPrice, setNextPrice] = useState<number | null>(null);
  const [quoteWorkOrderNoForPrice, setQuoteWorkOrderNoForPrice] =
    useState<String | null>(null);
  const [updated_at, setUpdated_at] = useState<Date | null>(null);
  const [priceId, setPriceId] = useState<number | null>(null);

  const [currentPriceQueryParams, setCurrentPriceQueryParams] =
    useState<IPriceHistoryPayload | null>(null);

  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [editingIndex, setEditingIndex] = useState<number | null>(null);
    const [canadianCities, setCanadianCities] = useState<string[]>([]); 
    const [busCount, setBusCount] = useState<number | null>(null);
    const [taxAmount, setTaxAmount] = useState<number>(0);
  
      const [originalProduct, setOriginalProduct] = useState<IProduct | null>(null); 

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024; // 2 MB

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        return;
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        return;
      } else {
        try {
          setIsImageUploading(true);
          const uploadedImageUrl = await uploadImage(file);
          const updatedRows = [...productRows];
          updatedRows[index].productImg = uploadedImageUrl;
          setProductRows(updatedRows);
          setIsImageUploading(false);
        } catch (error) {
          showErrorMessage("Failed to upload the image.");
          setIsImageUploading(false);
        }
      }
    }
  };

  const { data: taxData, isLoading: taxLoading } = useGetTaxQuery({
    searchText: "",
  });

  const taxList = useMemo(() => {
    return taxData?.data as ITaxes[];
  }, [taxData?.data]);

  const [productRows, setProductRows] = useState<IProduct[]>([
    {
      productName: "",
      productDescription: "",
      productImg: "",
      numberOfPassengers: null,
      busCount: null,
      transferType: TransferType.OneWayTransfer,
      transferTypeFrom: "",
      transferTypeTo: "",
      transferTypeDescription: "",
      departureDateTime: null,
      returnDateTime: null,
      departureAddress: "",
      destinationAddress: "",
      multiDestination: "",
      quantity: 1,
      price: null,
      tax: 0,
      taxAmount: 0,
      total: 0,
      taxId: null,
      unitPriceWithDiscount: null,
      unitTotalWithDiscount: 0,
      productType: ProductType.Bus,
      productLongDescription: "",
      productShortDescription: "",
    },
  ]);
  const [discounts, setDiscounts] = useState<IDiscount[]>([
    { value: null, description: "" },
  ]);
  const [discountValue, setDiscountValue] = useState<number>(0);
  const [discountDescription, setDiscountDescription] = useState<string>("");
  const [subTotal, setSubTotal] = useState<number>(0);
  const [totalDiscount, setTotalDiscount] = useState<number>(0);
  const [grandTotal, setGrandTotal] = useState<number>(0);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [unitPrice, setUnitPrice] = useState<number>(0);
  const [grandTotalEithDiscount, setGrandTotalWithDiscount] =
    useState<number>(0);
  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState<string | null>(
    null
  );
  const [openCompany, setOpenCompany] = useState(false);
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;

  const { data: workOrderLastData, isLoading: workOrderIsLoading } =
    useGetLastWorkOrderIdQuery();

  const {
    data: productData,
    isLoading: productIsLoading,
    refetch: productRefetch,
  } = useGetProductQuery({
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: currentSearchQueryProduct,
    createdDate: null,
    id: null,
  });

  useEffect(() => {
    if (
      debouncedSearchQueryProduct.length >= 2 ||
      debouncedSearchQueryProduct === ""
    ) {
      setCurrentSearchQueryProduct(debouncedSearchQueryProduct);
      productRefetch();
    }
  }, [debouncedSearchQueryProduct, productRefetch]);

  const initialParams: IPriceHistoryPayload = {
    productName: "",
    transferTypeFrom: "",
    transferTypeTo: "",
  };

  const {
    data: priceHistoryData,
    isLoading: priceHistoryIsLoading,
    isError: priceHistoryError,
    refetch: priceHistoryRefetch,
  } = useGetPriceHistoryQuery(
    currentPriceQueryParams ? currentPriceQueryParams : initialParams,
    {
      skip: false,
    }
  );

  useEffect(() => {
    if (
      priceHistoryData &&
      Array.isArray(priceHistoryData.data) &&
      priceHistoryData.data.length > 0
    ) {
      setAveragePrice(priceHistoryData.data[0]?.averagePrice || null);
      setNextPrice(priceHistoryData.data[0]?.price || null);
      setQuoteWorkOrderNoForPrice(
        priceHistoryData.data[0]?.quoteWorkOrderNo || null
      );
      setUpdated_at(priceHistoryData.data[0]?.updated_at || null);
      setPriceId(priceHistoryData.data[0]?.workOrderId || null);
    } else {
      setAveragePrice(null);
      setNextPrice(null);
      setQuoteWorkOrderNoForPrice(null);
      setUpdated_at(null);
      setPriceId(null);
    }
  }, [priceHistoryData]);

  useEffect(() => {
    if (WorkOrderDataList?.company?.companyName) {
      setSearchQuery(WorkOrderDataList.company.companyName);
    }
    if (WorkOrderDataList?.customer) {
      
      setSearchQueryCustomer(WorkOrderDataList?.customer?.customerCompanyName?.trim()
    ? WorkOrderDataList?.customer?.customerCompanyName
    : `${WorkOrderDataList?.customer?.customerFirstName || ""} ${WorkOrderDataList?.customer?.customerLastName || ""}`
      );
    }
    if (WorkOrderDataList?.company?.CompanyLogo) {
      setSelectedCompanyLogo(WorkOrderDataList.company.CompanyLogo);
    }
  }, [WorkOrderDataList]);
  

  const rawData = workOrderLastData?.data;
  const workOrderId =
    typeof rawData === "number"
      ? rawData
      : parseInt(rawData as string, 10) || 0;

  const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);

  useEffect(() => {
    const totalSubTotal = productRows.reduce((acc, row) => acc + row.total, 0);
    setSubTotal(totalSubTotal);

    const calculatedTotalDiscount = discounts.reduce(
      (acc, discount) => acc + (discount.value ?? 0),
      0
    );
    setTotalDiscount(calculatedTotalDiscount);

    const totalGrandTotal = totalSubTotal - calculatedTotalDiscount;
    setGrandTotal(totalGrandTotal);

    const unitPrice = calculatedTotalDiscount / totalSubTotal;
    setUnitPrice(unitPrice);

      const calculatedHst = productRows.reduce((acc, row) => {
   return acc + (row.taxAmount ?? 0);
   }, 0);
    setTaxAmount(calculatedHst);

    const totalSubTotalWithDiscount = productRows.reduce(
      (acc, row) => acc + row.unitTotalWithDiscount,
      0
    );
    setGrandTotalWithDiscount(totalSubTotalWithDiscount);
  }, [productRows, discounts]);

  const productList: IProductPopUP[] = Array.isArray(productData?.data)
    ? (productData?.data as IProductPopUP[])
    : [];

  const today = dayjs();

  const handleProductSelect = (product: IProductPopUP, index: number) => {
    const updatedRows = [...productRows];
    updatedRows[index].productName = product.productName;
    updatedRows[index].productImg = product.productImg || "";

    setProductRows(updatedRows);
    setShowDropdownProductIndex(null);
    updatePriceQueryParams(updatedRows[index]);
  };

const handleAddRow = () => {
     setEditIndex(null);
     setPopupOpen(true);
     
     setProductRows((prev) => [
       ...prev,
       {
         productName: "",
         productDescription: "",
         productImg: "",
         numberOfPassengers: null,
         busCount: null,
         transferType: TransferType.OneWayTransfer,
         transferTypeFrom: "",
         transferTypeTo: "",
         transferTypeDescription: "",
         departureDateTime: null,
         returnDateTime: null,
         departureAddress: "",
         destinationAddress: "",
         multiDestination: "",
         quantity: 1,
         price: null,
         tax: 0,
         taxAmount: 0,
         total: 0,
         taxId: 1,
         unitPriceWithDiscount: null,
         unitTotalWithDiscount: 0,
         productType: ProductType.Bus,
         productLongDescription: "",
         productShortDescription: "",
       },
     ]);
     setSearchQueryProduct("");
   };
 
   const handlePriceChange = (index: number, newPrice: number) => {
     const updatedRows = [...productRows];
     const product = updatedRows[index];
     product.price = newPrice;
   
     // Recalculate the tax amount whenever the price changes
     const newTaxAmount = newPrice * (product.tax / 100);
     product.taxAmount = newTaxAmount;
   
     setProductRows(updatedRows);
   };
 
   const handleCancel = () => {
     if (editIndex !== null && originalProduct) {
       // Log the original product row before canceling
       console.log("Reverting to the original product row:", originalProduct);
   
       // Revert to the original product data (before editing)
       setProductRows(prevRows => {
         const updatedRows = [...prevRows];
         updatedRows[editIndex] = originalProduct; // Restore the original row
         return updatedRows;
       });
   
     
       setEditIndex(null);    // Clear edit index
       setOriginalProduct(null);  // Clear original product data after canceling
     } else {
       // If no row is being edited, just close the popup and remove the last empty row if necessary
       const lastRow = productRows[productRows.length - 1];
       if (
         !lastRow?.productName ||
         !lastRow?.productDescription ||
         !lastRow?.price ||
         (lastRow?.tax && lastRow?.tax <= 0)
       ) {
         console.log("Removing last row because it's empty or invalid");
         setProductRows(productRows.slice(0, productRows.length - 1));
       }
     }
     setPopupOpen(false);  // Close the popup
   };

  const handleFieldChange = <K extends keyof IProduct>(
    index: number,
    field: K,
    value: IProduct[K]
  ) => {
    const updatedRows = [...productRows];
    updatedRows[index][field] = value;

    const price = updatedRows[index].price ?? 0;
    const quantity = updatedRows[index].quantity ?? 0;
    const tax = updatedRows[index].tax ?? 0;

    updatedRows[index].total = price * quantity;

    const totalSubTotal = updatedRows.reduce((acc, row) => acc + row.total, 0);

    const totalDiscountValue = discounts.reduce(
      (acc, discount) => acc + (discount.value ?? 0),
      0
    );

    const unitPriceDiscount = totalDiscountValue / totalSubTotal;

    const priceWithDiscount = price * (1 - unitPriceDiscount);

    const unitProductPriceWithDiscountAndTax =
      priceWithDiscount * (1 + tax / 100);

    const totalWithDiscountAndTax =
      priceWithDiscount * quantity * (1 + tax / 100);

    updatedRows[index].unitPriceWithDiscount =
      unitProductPriceWithDiscountAndTax;
    updatedRows[index].unitTotalWithDiscount = totalWithDiscountAndTax;

    setProductRows(updatedRows);

    const priceAffectingFields = ["productName", "transferTypeFrom", "transferTypeTo"] as const;
    if (
      (priceAffectingFields as readonly string[]).includes(field as string) &&
      updatedRows[index].productName &&
      updatedRows[index].transferTypeFrom &&
      updatedRows[index].transferTypeTo
    ) {
      updatePriceQueryParams(updatedRows[index]);
      setCurrentIndex(index);
    }
  };

  const updatePriceQueryParams = (row: IProduct) => {
    const { productName, transferTypeFrom, transferTypeTo } = row;

    if (productName && transferTypeFrom && transferTypeTo) {
      const newParams: IPriceHistoryPayload = {
        productName,
        transferTypeFrom,
        transferTypeTo,
      };

      setCurrentPriceQueryParams(newParams);

      if (newParams) {
        priceHistoryRefetch();
      }
    } else {
      console.error("Incomplete parameters for price query.");
    }
  };

  useEffect(() => {
    if (productRows.length > 0) {
      const totalSubTotal = productRows.reduce(
        (acc, row) => acc + row.total,
        0
      );
      setSubTotal(totalSubTotal);

      const calculatedTotalDiscount = discounts.reduce(
        (acc, discount) => acc + (discount.value ?? 0),
        0
      );
      setTotalDiscount(calculatedTotalDiscount);

      if (totalSubTotal > 0) {
        const unitPriceDiscount = totalDiscount / totalSubTotal;
        setUnitPrice(unitPriceDiscount);

        const updatedRows = productRows.map((row) => {
          const price = row.price ?? 0;
          const quantity = row.quantity ?? 0;
          const tax = row.tax ?? 0;

          const priceWithDiscount = price * (1 - unitPriceDiscount);
          const unitProductPriceWithDiscountAndTax =
            priceWithDiscount * (1 + tax / 100);
          const totalWithDiscountAndTax =
            priceWithDiscount * quantity * (1 + tax / 100);

            const taxAmountWithDiscount = priceWithDiscount * (tax / 100);

          return {
            ...row,
            unitPriceWithDiscount: unitProductPriceWithDiscountAndTax,
            unitTotalWithDiscount: totalWithDiscountAndTax,
            taxAmount: taxAmountWithDiscount, // Updating taxAmount after discount
          };
        });

        setProductRows((prevRows) => {
          // Only update the state if rows have actually changed
          if (JSON.stringify(prevRows) !== JSON.stringify(updatedRows)) {
            return updatedRows;
          }
          return prevRows;
        });

        const totalSubTotalWithDiscount = updatedRows.reduce(
          (acc, row) => acc + row.unitTotalWithDiscount,
          0
        );
        setGrandTotalWithDiscount(totalSubTotalWithDiscount);
      }
    }
  }, [productRows, discounts, totalDiscount]);

  const handleProductNameChange = (index: number, value: string) => {
    setSearchQueryProduct(value);
    handleFieldChange(index, "productName", value);
  };

  

  const handleDeleteRow = (index: number) => {
    // const updatedRows = productRows.filter((_, i) => i !== index);
     const updatedRows = [...productRows];
     updatedRows.splice(index, 1);
     setProductRows(updatedRows);
    // console.log(updatedRows)
   };

   const handleEditRow = (index: number) => {
    const productToEdit = productRows[index];
    setOriginalProduct({ ...productToEdit });
    setEditIndex(index);
    setPopupOpen(true);
    //console.log("Editing product: ", productToEdit);

  };

  const handleDiscountChange = (
    index: number,
    field: keyof IDiscount,
    value: any
  ) => {
    const updatedDiscounts = [...discounts];
    updatedDiscounts[index] = {
      ...updatedDiscounts[index],
      [field]: value,
    };
    setDiscounts(updatedDiscounts);
  };

  const handleOpenDialog = (index: number | null) => {
    if (index !== null) {
      // Editing existing discount
      const discountToEdit = discounts[index];
      setDiscountValue(discountToEdit.value ?? 0);
      setDiscountDescription(discountToEdit.description);
      setEditingIndex(index); // Set the index of the item being edited
    } else {
      // Adding a new discount
      setDiscountValue(0);
      setDiscountDescription("");
      setEditingIndex(null); // Reset editing index
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDiscountValue(0);
    setDiscountDescription("");
    setEditingIndex(null);
  };
  const handleSaveDiscount = () => {
    if (editingIndex !== null) {
      // Update existing discount
      const updatedDiscounts = discounts.map((discount, index) =>
        index === editingIndex
          ? { value: discountValue, description: discountDescription }
          : discount
      );
      setDiscounts(updatedDiscounts);
    } else {
      // Add a new discount
      setDiscounts((prev) => [
        ...prev,
        { value: discountValue, description: discountDescription },
      ]);
    }
    handleCloseDialog();
  };

  const handleDeleteDiscount = (index: number) => {
    const updatedDiscounts = discounts.filter((_, i) => i !== index);
    setDiscounts(updatedDiscounts);
  };

  const formatAddressReadOnly = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };


const formatCustomerAddressReadOnly = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };

  const formatProjectAddressReadOnly = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };

  const initialCompanyAddress = formatAddressReadOnly(
    WorkOrderDataList?.company.companyStreetNumber || "",
    WorkOrderDataList?.company.companyStreetName || "",
    WorkOrderDataList?.company.companyCity || "",
    WorkOrderDataList?.company.companyProvince || "",
    WorkOrderDataList?.company.companyPostalCode || "",
  );

  const initialCustomerAddress = formatCustomerAddressReadOnly(
    WorkOrderDataList?.customer.customerStreetNumber || "",
    WorkOrderDataList?.customer.customerStreetName || "",
    WorkOrderDataList?.customer.customerCity || "",
    WorkOrderDataList?.customer.customerProvince || "",
    WorkOrderDataList?.customer.customerPostalCode || "",
  );

  const initialProjectAddress = formatProjectAddressReadOnly(
    WorkOrderDataList?.project.projectStreetNumber || "",
    WorkOrderDataList?.project.projectStreetName || "",
    WorkOrderDataList?.project.projectCity || "",
    WorkOrderDataList?.project.projectProvince || "",
    WorkOrderDataList?.project.projectPostalCode || "",
  );

  const formik = useFormik({
    initialValues: {
      id: WorkOrderDataList?.id,
      companyName: WorkOrderDataList?.company.companyName || "",
      companyLogo: WorkOrderDataList?.company.CompanyLogo || "",
      companyProvince: WorkOrderDataList?.company.companyProvince || "",
      companyCity: WorkOrderDataList?.company.companyCity || "",
      companyPostalCode: WorkOrderDataList?.company.companyPostalCode || "",
      companyStreetNumber: WorkOrderDataList?.company.companyStreetNumber || "",
      companyStreetName: WorkOrderDataList?.company.companyStreetName || "",
      companyMobileNumber: WorkOrderDataList?.company.companyMobileNumber || "",
      companyEmail: WorkOrderDataList?.company.companyEmail || "",
      companyAddress: initialCompanyAddress,
      customerProjectName:
        WorkOrderDataList?.project.projectName || "",
  
      projectMobileNum: WorkOrderDataList?.project.projectPhoneNumber || "",
      projectEmail: WorkOrderDataList?.project.projectEmail || "",
      projectProvince: WorkOrderDataList?. project. projectProvince || "",
      projectCity: WorkOrderDataList?. project. projectCity || "",
      projectPostalCode: WorkOrderDataList?. project.projectPostalCode || "",
      projectStreetNumber: WorkOrderDataList?. project. projectStreetNumber || "",
      projectStreetName: WorkOrderDataList?. project. projectStreetName || "",

      customerAddress: initialCustomerAddress,

      projectAddress: initialProjectAddress,

      InvoiceNo: WorkOrderDataList?.InvoiceNo || "",
      po_number: WorkOrderDataList?.po_number || "",
      quoteWorkOrderNo: WorkOrderDataList?.quoteWorkOrderNo || "",
      quoteWorkOrderIssueDate: dayjs(
        WorkOrderDataList?.quoteWorkOrderIssueDate
      ),
      quoteWorkOrderDueDate: dayjs(WorkOrderDataList?.quoteWorkOrderDueDate),
     // quoteWorkOrderStatus: WorkOrderDataList?.quoteWorkOrderStatus || "",
      quoteWorkOrderStatus: WorkOrderDataList?.quoteWorkOrderStatus ?? "",
      quoteWorkOrderSale: [],
      quoteWorkOrderSaleDiscount:
        WorkOrderDataList?.quoteWorkOrderSaleDiscount || "",
      quoteWorkOrderSaleSubTotal:
        WorkOrderDataList?.quoteWorkOrderSaleSubTotal || "",
      quoteWorkOrderSaleGrandTotal:
        WorkOrderDataList?.quoteWorkOrderSaleGrandTotal || "",
      quoteWorkOrderSaleDiscountDescription: [],
      quoteWorkOrderCompanyId: WorkOrderDataList?.quoteWorkOrderCompanyId || "",
      quoteWorkOrderCustomerId:
        WorkOrderDataList?.quoteWorkOrderCustomerId || "",
      
        quoteWorkOrderCustomerProjectId:
        WorkOrderDataList?.quoteWorkOrderCustomerProjectId || "",
     
        quoteWorkOrderCustomerRemark:
        WorkOrderDataList?.quoteWorkOrderCustomerRemark || "",
      quoteWorkOrderCustomerMemo:
        WorkOrderDataList?.quoteWorkOrderCustomerMemo || "",

      
    },

    enableReinitialize: true,
    validate: (values) => {
      const errors: { [key: string]: string } = {};

      const mobileNumberError = validatePhoneNumber(values.companyMobileNumber);
      if (mobileNumberError) {
        errors.companyMobileNumber = mobileNumberError;
      }

      const emailError = validateEmail(values.companyEmail);
      if (emailError) {
        errors.companyEmail = emailError;
      }

      const customerMobileNumberError = validatePhoneNumber(
        values.projectMobileNum
      );
      if (customerMobileNumberError) {
        errors.customerMobileNum = customerMobileNumberError;
      }

      const customerEmailError = validateEmail(values.projectEmail);
      if (customerEmailError) {
        errors.customerEmail = customerEmailError;
      }

      return errors;
    },

    onSubmit: async (values, { resetForm }) => {
      try {
        // Backfill backend-required row fields so editing pickup time
        // doesn't strip productName / transferTypeFrom / transferTypeTo.
        const normalizedRows = productRows.map((row) => {
          const firstPickup = (row as any).pickups?.[0];
          const firstDropoff = (row as any).dropoffs?.[0];
          return {
            ...row,
            productName:
              (row.productName && String(row.productName).trim()) ||
              (row as any).productType ||
              "Service",
            transferTypeFrom:
              (row.transferTypeFrom && String(row.transferTypeFrom).trim()) ||
              firstPickup?.city ||
              firstPickup?.address ||
              "—",
            transferTypeTo:
              (row.transferTypeTo && String(row.transferTypeTo).trim()) ||
              firstDropoff?.city ||
              firstDropoff?.address ||
              "—",
          };
        });
        const temData = {
          id: values.id,
          companyName: values.companyName,
          companyLogo: values.companyLogo,
          companyProvince: values.companyProvince,
          companyCity: values.companyCity,
          companyPostalCode: values.companyPostalCode,
          companyStreetNumber: values.companyStreetNumber,
          companyStreetName: values.companyStreetName,
          companyMobileNumber: values.companyMobileNumber,
          customerMobileNum: values.projectMobileNum,
          companyEmail: values.companyEmail,
          companyAddress: values.companyAddress,
          quoteWorkOrderNo: values.quoteWorkOrderNo,
          po_number: values.po_number,
          quoteWorkOrderIssueDate: values.quoteWorkOrderIssueDate,
          quoteWorkOrderDueDate: values.quoteWorkOrderDueDate,
          quoteWorkOrderStatus: String(values.quoteWorkOrderStatus),
          customerProjectName: values.customerProjectName,
          customerEmail: values.projectEmail,

          projectProvince: values.projectProvince,
          projectCity: values.projectCity,
          projectPostalCode: values.projectPostalCode,
          projectStreetNumber: values.projectStreetNumber,
          projectStreetName: values.projectStreetName,

          // Persist datetimes as Toronto wall-clock time (no UTC Z suffix)
          quoteWorkOrderSale: normalizeDateTimeFields(normalizedRows),
          quoteWorkOrderDiscount: String(totalDiscount),
          quoteWorkOrderSubTotal: String(subTotal),
          quoteWorkOrderSaleGrandTotal: String(grandTotalEithDiscount),
          quoteWorkOrderSaleDiscountDescription: discounts,
          quoteWorkOrderCompanyId: String(values.quoteWorkOrderCompanyId),
          quoteWorkOrderCustomerId: String(values.quoteWorkOrderCustomerId),
       //   quoteWorkOrderCustomerProjectId: String(values.quoteWorkOrderCustomerProjectId),
          quoteWorkOrderCustomerRemark: values.quoteWorkOrderCustomerRemark,
          quoteWorkOrderCustomerMemo: values.quoteWorkOrderCustomerMemo,
       
        };
      

        const addCompanyResponse = await newTax(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          navigate(-1);   
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.companyName === "" ||
      formik.values.companyName === undefined ||
      // formik.values.projectMobileNum === "" ||
      // formik.values.projectMobileNum === undefined ||
      formik.values.customerProjectName === "" ||
      formik.values.customerProjectName === undefined ||
      formik.values.quoteWorkOrderStatus === "" ||
      formik.values.quoteWorkOrderStatus === undefined
      ? false
      : true;
  }, [formik]);

  if (
    isLoading ||
    taxLoading ||
    workOrderIsLoading ||
    productIsLoading ||
    workIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Card className={classes.quotesCard}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} padding={2}>
            {WorkOrderDataList?.isInvoice == true && (
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ paddingBottom: 3 }}
                className={classes.titleGrid}
              >
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Alert severity="success">
                      This work order has been converted to an invoice.
                    </Alert>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={5}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={3} md={3} sm={4} xs={4}>
                      {selectedCompanyLogo ? (
                        <img
                        src={`${LARAVEL_API_URL}/${selectedCompanyLogo}`}
                          alt="Company Logo"
                          className={classes.quoteImg}
                        />
                      ) : (
                        <div style={{
                          width: 80, height: 80, borderRadius: "50%",
                          background: "#2f3891",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 36, fontWeight: 800, color: "#fff",
                        }}>
                          {(formik.values.companyName || "C").charAt(0).toUpperCase()}
                        </div>
                      )}
                    </Grid>
                    <Grid
                      item
                      lg={9}
                      md={9}
                      sm={9}
                      xs={9}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <Button
                            variant="outlined"
                            startIcon={<ArrowBackIosIcon />}
                            className={classes.addButton}
                            onClick={() => navigate(-1)}
                          >
                            Back
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Invoice Number :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Invoice Number :"
                            size="small"
                            {...formik.getFieldProps("InvoiceNo")}
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Issue Date :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={formik.values.quoteWorkOrderIssueDate}
                              onChange={(date) =>
                                formik.setFieldValue(
                                  "quoteWorkOrderIssueDate",
                                  date
                                )
                              }
                              // defaultValue={today}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  sx: { width: "100%" },
                                  InputProps: {
                                    sx: { fontSize: 14 },
                                  },
                                  InputLabelProps: {
                                    sx: { fontSize: 14 },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>

     <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            PO Number :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter PO Number"
                            size="small"
                            {...formik.getFieldProps("po_number")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>



                  </Grid>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid
                    container
                    spacing={3}
                    display={"flex"}
                    justifyContent={"flex-end"}
                  >
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Status :</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            select
                            size="small"
                            className={classes.textField}
                            SelectProps={{
                              native: false,
                            }}
                            defaultValue=""
                            InputLabelProps={{ shrink: true }}
                            {...formik.getFieldProps("quoteWorkOrderStatus")}
                          >
                            <MenuItem value="" disabled>
                              Select an option
                            </MenuItem>

                            {Object.entries(WorkOrderStatus).map(
                              ([key, value], index) => (
                                <MenuItem key={index} value={value}>
                                  {key}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>



                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Due Date :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={formik.values.quoteWorkOrderDueDate}
                              onChange={(date) =>
                                formik.setFieldValue(
                                  "quoteWorkOrderDueDate",
                                  date
                                )
                              }
                              slotProps={{
                                textField: {
                                  size: "small",
                                  sx: { width: "100%" },
                                  InputProps: {
                                    sx: { fontSize: 14 },
                                  },
                                  InputLabelProps: {
                                    sx: { fontSize: 14 },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={5}>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item>
                          <Typography className={classes.h4Quoto}>
                            Issue From :
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CiSearch
                                    className={classes.searchWidgetIcon}
                                  />
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.formControlListQuto,
                                notchedOutline: classes.notchedOutline,
                              },
                              readOnly: true,
                            }}
                            value={searchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                              setShowDropdown(true);
                            }}
                            placeholder="Company Name .."
                            size="small"
                            defaultValue={""}
                            sx={{ flexGrow: 1, width: "100%" }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Company Name"
                        size="small"
                        {...formik.getFieldProps("companyName")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Company Address"
                        size="small"
                        value={formik.values.companyAddress}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        multiline
                        rows={5}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Phone Number"
                        size="small"
                        {...formik.getFieldProps("companyMobileNumber")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.companyMobileNumber &&
                          Boolean(formik.errors.companyMobileNumber)
                        }
                        helperText={
                          formik.touched.companyMobileNumber &&
                          formik.errors.companyMobileNumber
                        }
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Email"
                        size="small"
                        {...formik.getFieldProps("companyEmail")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.companyEmail &&
                          Boolean(formik.errors.companyEmail)
                        }
                        helperText={
                          formik.touched.companyEmail &&
                          formik.errors.companyEmail
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid
                    container
                    spacing={3}
                    display={"flex"}
                    justifyContent={"flex-end"}
                  >
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item>
                          <Typography className={classes.h4Quoto}>
                            Issue For:
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CiSearch
                                    className={classes.searchWidgetIcon}
                                  />
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.formControlListQuto,
                                notchedOutline: classes.notchedOutline,
                              },
                              readOnly: true,
                            }}
                            value={searchQueryCustomer}
                            onChange={(e) => {
                              setSearchQueryCustomer(e.target.value);
                              setShowDropdownCustomer(true);
                            }}
                            placeholder="Name & phone number .."
                            size="small"
                            sx={{ flexGrow: 1, width: "100%" }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Name"
                        size="small"
                        {...formik.getFieldProps("customerProjectName")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Address"
                        size="small"
                        {...formik.getFieldProps("projectAddress")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        multiline
                        rows={5}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Phone Number"
                        size="small"
                        {...formik.getFieldProps("projectMobileNum")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.projectMobileNum &&
                          Boolean(formik.errors.projectMobileNum)
                        }
                        helperText={
                          formik.touched.projectMobileNum &&
                          formik.errors.projectMobileNum
                        }
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Email"
                        size="small"
                        {...formik.getFieldProps("projectEmail")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.projectEmail &&
                          Boolean(formik.errors.projectEmail)
                        }
                        helperText={
                          formik.touched.projectEmail &&
                          formik.errors.projectEmail
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} mt={5}>
                                  <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    spacing={2}
                                  >
                                    <TableContainer>
                                    <Table className={classes.table}>
                                        <TableHead className={classes.tableHeaderRow}>
                                          <TableRow>
                                            <TableCell className={classes.tablheader}>
                                              <strong>Bus & Services Information</strong>
                                            </TableCell>

                                            <TableCell className={classes.tablheader}>
                                              <strong>Trip Information</strong>
                                            </TableCell>
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Quantity</strong>
                                            </TableCell> */}
                                            <TableCell className={classes.tablheader}>
                                              <strong>Price</strong>
                                            </TableCell>
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Tax</strong>
                                            </TableCell> */}
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Unit Price</strong>
                                            </TableCell> */}
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Total</strong>
                                            </TableCell> */}
                                             <TableCell  className={classes.tablheader}
                                                                          sx={{ textAlign: "right" }}
                                                                        >
                                              <strong>Actions</strong>
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                
                
                                        <TableBody>
                      {productRows.map((product, index) => (
                        <TableRow key={index}>
                          {/* Product Details */}
                          <TableCell
                                                          component="th"
                                                          scope="row"
                                                          className={classes.tablCell}
                                                            
                                                          
                                                        >
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                              {product.productName || ""}
                            </Typography>
                            <Typography variant="body2" >
                              {product.productDescription || ""}
                            </Typography>
                            <Typography variant="body2" >
                            {product.numberOfPassengers && `${product.numberOfPassengers} Passengers`} 
                            {product.numberOfPassengers && product.busCount ? " | " : ""}
                            {product.busCount && `${product.busCount} bus`}
  {/* {product.numberOfPassengers && product.transferType ? " | " : ""}
  {product.transferType 
    ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
        .find((key) => TransferType[key] === String(product.transferType))
    : ""} */}
</Typography>


                          </TableCell>

                          <TableCell
                                                          component="th"
                                                          scope="row"
                                                          className={classes.tablCell}
                                                          
                                                          
                                                        >

<Typography variant="body2" >

<Typography variant="subtitle1" component="div" gutterBottom>
  {product.transferType
    ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
        .find((key) => TransferType[key] === String(product.transferType))
    : ""}
  {product.transferTypeFrom && product.transferTypeTo ? ` (${product.transferTypeFrom} to ${product.transferTypeTo})` : ""}
</Typography>
                            </Typography>
                            {product.departureAddress && product.departureDateTime && (
  <Typography variant="body2" component="div" gutterBottom>
    <strong>Departure:</strong>{" "}
    {product.departureAddress} <div>(
    {dayjs.isDayjs(product.departureDateTime)
      ? product.departureDateTime.format("DD-MMM-YY hh:mm A")
      : product.departureDateTime}
    )</div>
  </Typography>
)}

 {product.destinationAddress && (
  <Typography variant="body2" component="div" gutterBottom>
    <>
      <strong>Destination:</strong> {product.destinationAddress}
      {product.returnDateTime && dayjs(product.returnDateTime).isValid() && (
        <>
          <br /> ({dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")})
        </>
      )}
    </>
  </Typography>
)}
                        
                          </TableCell>
                
                          {/* Price */}
                           <TableCell
                                                           component="th"
                                                           scope="row"
                                                           className={classes.tablCell}
                                                         >
                          <Typography variant="body1">
                  ${product.price != null ? product.price.toFixed(2) : "0.00"}
                </Typography>
                
                          </TableCell>
                
                          {/* Tax */}
                           {/* <TableCell
                                                           component="th"
                                                           scope="row"
                                                           className={classes.tablCell}
                                                         >
                            <Typography variant="body1">
                              {product.taxAmount ? `${product.taxAmount.toFixed(2)}` : "0.00"}
                            </Typography>
                          </TableCell> */}
                
                          {/* Total */}
                          {/* <TableCell
                                                          component="th"
                                                          scope="row"
                                                          className={classes.tablCell}
                                                        >
                            <Typography variant="body1">
                              ${product.unitTotalWithDiscount ? product.unitTotalWithDiscount.toFixed(2) : "0.00"}
                            </Typography>
                          </TableCell> */}
                
                          {/* Actions */}
                          <TableCell  scope="row" className={classes.tablCell}
                                                         >
                                                           <Grid
                                                             container
                                                             spacing={1}
                                                             sx={{
                                                               display: "flex",
                                                               justifyContent: "flex-end",
                                                             }}
                                                           >
                
                                                                 <Grid item>
                            <IconButton
                              color="primary"
                              onClick={() => handleEditRow(index)}
                            >
                              <FaEdit  style={{ fontSize: 18 }}/>
                            </IconButton>
                            </Grid>
                            <Grid item>
                            <IconButton
                              color="primary"
                              onClick={() => handleDeleteRow(index)}
                            >
                              <FaTrash style={{ fontSize: 16 }} />
                            </IconButton>
                            </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      py={2}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        className={classes.addButton}
                        onClick={handleAddRow}
                      >
                        Product
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Dialog open={popupOpen} onClose={() => setPopupOpen(false)}>
            <DialogTitle>{editIndex !== null ? "Edit Product" : "Add Product"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>

     
        <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                           Product Name 
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
          size="small"
          fullWidth
          value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.productName}
          onChange={(e) => handleProductNameChange(editIndex !== null ? editIndex : productRows.length - 1, e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CiSearch className={classes.searchWidgetIcon} />
              </InputAdornment>
            ),
            classes: {
              root: classes.formControlListQuto,
              notchedOutline: classes.notchedOutline,
            },
          }}
          onFocus={() => setShowDropdownProductIndex(editIndex !== null ? editIndex : productRows.length - 1)}
        />

{showDropdownProductIndex === (editIndex !== null ? editIndex : productRows.length - 1) && (
          <Paper className={classes.dropdownPaper}>
            {productIsLoading ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                <CircularProgress size={24} />
              </div>
            ) : (
              productList.length > 0 &&
              productList.map((Product) => (
                <MenuItem
                  key={Product.id}
                  onClick={() => handleProductSelect(Product, editIndex !== null ? editIndex : productRows.length - 1)}
                >
                  <img
                     src={Product.productImg ?`${LARAVEL_API_URL}/${String(Product.productImg)}` : placeholderImage}
                 
                   // src={String(Product.productImg)}
                    className={classes.quoteImgSelctMenu}
                    alt="img"
                  />
                  {Product.productName}
                </MenuItem>
              ))
            )}
          </Paper>
        )}
          </Grid>
          </Grid>
          </Grid>


 <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                          Product Type
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                        <TextField  select
                          size="small"
                          value={
                            productRows[editIndex !== null ? editIndex : productRows.length - 1]?.productType ?? ""
                          }
                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "productType", String(e.target.value))}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        >
                           <MenuItem value="" disabled>
                                            Select an option
                                          </MenuItem>

                                          {Object.entries(ProductType).map(
                                            ([key, value], index) => (
                                              <MenuItem
                                                key={index}
                                                value={value}
                                              >
                                                {key}
                                              </MenuItem>
                                            )
                                          )} </TextField>
                      </Grid>
                    </Grid>
                  </Grid>


                  <Grid item lg={6} md={6} sm={6} xs={12}>
                                      <Grid container alignItems="center">
                                        <Grid  item xs={12}>
                                          <Typography variant="subtitle1">
                                           Bus Count
                                          </Typography>
                                        </Grid>
                                        <Grid  item xs={12}>
                                        <TextField
                                            placeholder="Enter bus count .."
                                            size="small"
                                            type="number"
                                            value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.busCount}
                                            onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "busCount",  Number(e.target.value))}
                                            className={classes.discriptionTextField}
                                            InputProps={{
                                              sx: {
                                                fontSize: 14,
                                              },
                                            }}
                                            InputLabelProps={{
                                              sx: {
                                                fontSize: 14,
                                              },
                                            }}
                                          />
                                          </Grid>
                                      </Grid>
                                    </Grid>


                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         No Of Passengers
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <TextField
                          placeholder="Enter No of passengers .."
                          size="small"
                          value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.numberOfPassengers}
                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "numberOfPassengers",  Number(e.target.value))}
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                        </Grid>
                    </Grid>
                  </Grid>

                  
 <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                          Transfer Type
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                        <TextField  select
                          size="small"
                          value={
                            productRows[editIndex !== null ? editIndex : productRows.length - 1]?.transferType ?? ""
                          }

                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "transferType", String(e.target.value))}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        >
                              <MenuItem value="" disabled>   Select an option </MenuItem>
                                            {Object.entries(TransferType).map(
                                              ([key, value], index) => (
                                                <MenuItem
                                                  key={index}
                                                  value={value}
                                                >
                                                  {key}
                                                </MenuItem>
                                              )
                                            )} </TextField>
                      </Grid>
                    </Grid>
                  </Grid>

                 


          <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                          Description :
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Description .."
                          size="small"
                          multiline
                          rows={6}
                          value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.productDescription}
                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "productDescription", e.target.value)}
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
              
                  <Grid item xs={12}>
                <Typography variant="h6" component="h2"> Trip Information</Typography> 
                </Grid>  
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         Departure Address
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <TextField
                          placeholder="Enter Departure address .."
                          size="small"
                          value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.departureAddress}
                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "departureAddress",  String(e.target.value))}
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                        </Grid>
                        </Grid>
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         Departure City
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <Autocomplete
                       options={canadianCities.filter((value, index, self) => self.indexOf(value) === index)} // Deduplicate the array manually
                       value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.transferTypeFrom || ""}
                       onChange={(event, newValue) =>
                         handleFieldChange(
                           editIndex !== null ? editIndex : productRows.length - 1,
                           "transferTypeFrom",
                           newValue ?? ""
                         )
                       }
                       getOptionLabel={(option) => option} // For string options
                       filterOptions={(options, state) => {
                         const inputValue = state.inputValue.toLowerCase();
                     
                         // First, find exact matches
                         const exactMatch = options.filter(option =>
                           option.toLowerCase() === inputValue
                         );
                     
                         // Then filter out matches containing the input value
                         const partialMatches = options.filter(option =>
                           option.toLowerCase().includes(inputValue) && option.toLowerCase() !== inputValue
                         );
                     
                         // Return exact matches first, followed by partial matches
                         return [...exactMatch, ...partialMatches];
                       }}
                       renderInput={(params) => (
                         <TextField
                           {...params}
                           placeholder="Enter Departure City..."
                           size="small"
                           className={classes.discriptionTextField}
                           InputProps={{
                             ...params.InputProps,
                             sx: { fontSize: 14 },
                           }}
                           InputLabelProps={{
                             sx: { fontSize: 14 },
                           }}
                         />
                       )}
                     />
                        </Grid>
                        </Grid>
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         Destination Address
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <TextField
                          placeholder="Enter Destination address .."
                          size="small"
                          value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.destinationAddress}
                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "destinationAddress",  String(e.target.value))}
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                        </Grid>
                        </Grid>
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         Destination City
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <Autocomplete
                                             options={canadianCities.filter((value, index, self) => self.indexOf(value) === index)} // Deduplicate the array manually
                                             value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.transferTypeTo || ""}
                                             onChange={(event, newValue) =>
                                               handleFieldChange(
                                                 editIndex !== null ? editIndex : productRows.length - 1,
                                                 "transferTypeTo",
                                                 newValue ?? ""
                                               )
                                             }
                                             getOptionLabel={(option) => option} // For string options
                                             filterOptions={(options, state) => {
                                               const inputValue = state.inputValue.toLowerCase();
                                           
                                               // First, find exact matches
                                               const exactMatch = options.filter(option =>
                                                 option.toLowerCase() === inputValue
                                               );
                                           
                                               // Then filter out matches containing the input value
                                               const partialMatches = options.filter(option =>
                                                 option.toLowerCase().includes(inputValue) && option.toLowerCase() !== inputValue
                                               );
                                           
                                               // Return exact matches first, followed by partial matches
                                               return [...exactMatch, ...partialMatches];
                                             }}
                                             renderInput={(params) => (
                                               <TextField
                                                 {...params}
                                                 placeholder="Enter Departure City..."
                                                 size="small"
                                                 className={classes.discriptionTextField}
                                                 InputProps={{
                                                   ...params.InputProps,
                                                   sx: { fontSize: 14 },
                                                 }}
                                                 InputLabelProps={{
                                                   sx: { fontSize: 14 },
                                                 }}
                                               />
                                             )}
                                           />
                        </Grid>
                        </Grid>
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         Departure date & time
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DateTimePicker
                                         value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.departureDateTime}
                                         onChange={(value) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "departureDateTime", value)}
                                          // viewRenderers={{
                                          //   hours: renderTimeViewClock,
                                          //   minutes: renderTimeViewClock,
                                          //   seconds: renderTimeViewClock,
                                          // }}
                                          slotProps={{
                                            textField: {
                                              placeholder:
                                                "Departure Date & Time",
                                              size: "small",
                                              sx: { width: "100%" },
                                              InputProps: {
                                                sx: { fontSize: 14 },
                                                classes: {
                                                  root: classes.textFieldQuote,
                                                
                                                },
                                              },
                                              InputLabelProps: {
                                                sx: { fontSize: 14 },
                                              },
                                            },
                                          }}
                                        />
                                      </LocalizationProvider>
                        </Grid>
                        </Grid>
                        </Grid>

{productRows[editIndex !== null ? editIndex : productRows.length - 1]?.transferType !== TransferType.OneWayTransfer && (
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         Return date & time
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DateTimePicker
                                         value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.returnDateTime}
                                         onChange={(value) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "returnDateTime", value)}
                                          // viewRenderers={{
                                          //   hours: renderTimeViewClock,
                                          //   minutes: renderTimeViewClock,
                                          //   seconds: renderTimeViewClock,
                                          // }}
                                          slotProps={{
                                            textField: {
                                              placeholder:
                                                "Return Date & Time",
                                              size: "small",
                                              sx: { width: "100%" },
                                              InputProps: {
                                                sx: { fontSize: 14 },
                                                classes: {
                                                  root: classes.textFieldQuote,
                                                },
                                              },
                                              InputLabelProps: {
                                                sx: { fontSize: 14 },
                                              },
                                            },
                                          }}
                                        />
                                      </LocalizationProvider>
                        </Grid>
                        </Grid>
                        </Grid>  
)} 
                         
                                          <Grid item  lg={12} md={12} sm={12} xs={12}>
                                         
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                     
                                          >
                                            {priceHistoryIsLoading && (
                                              <div
                                                style={{
                                                  textAlign: "center",
                                                  padding: "10px",
                                                }}
                                              >
                                                <CircularProgress size={24} />
                                              </div>
                                            )}
                                            {nextPrice && (
                                              <Alert
                                                icon={false}
                                                severity="success"
                                                sx={{ marginBottom: "1px" }}
                                              >
                                                <Typography>
                                                  L.Price: {nextPrice}{" "}
                                                  <span
                                                    style={{
                                                      marginLeft: "8px",
                                                    }}
                                                  >
                                                    {" "}
                                                    A.Price: {averagePrice}
                                                  </span>
                                                </Typography>

                                                <Typography
                                                  component="span"
                                                  sx={{ fontSize: "12px" }}
                                                >
                                                  {updated_at
                                                    ? new Date(
                                                        updated_at
                                                      ).toLocaleDateString()
                                                    : ""}
                                                  {"   "}
                                                  <Typography
                                                    component="span"
                                                    sx={{
                                                      color: "blue",
                                                      fontWeight: "bold",
                                                      cursor: "pointer",
                                                      textDecoration:
                                                        "underline",
                                                      marginLeft: "8px",
                                                      fontSize: "12px" 
                                                    }}
                                                    onClick={() =>
                                                      window.open(
                                                        `/work-order/history/${priceId}`,
                                                        "_blank"
                                                      )
                                                    }
                                                  >
                                                    {quoteWorkOrderNoForPrice}
                                                  </Typography>
                                                </Typography>
                                              </Alert>
                                            )}

{priceHistoryError && currentIndex !== null && (
  <Alert icon={false} severity="error">
    Error fetching price history for{" "}
    {productRows[currentIndex]?.productName}.
  </Alert>
)}      </Grid>
</Grid> 

                                       
               
             
                <Grid item xs={12}>
                <Typography variant="h6" component="h2"> Payment Details</Typography> 
                </Grid>                       
                  
          <Grid item lg={4} md={4} sm={6} xs={12}>
        <Grid container alignItems="center">

          <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                           Price 
                           </Typography>
                           </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
  size="small"
  type="number"
  fullWidth
  value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.price}
  onChange={(e) => handlePriceChange(editIndex !== null ? editIndex : productRows.length - 1, Math.max(0, Number(e.target.value)))}
 
/>

          </Grid>
          </Grid>
          </Grid>

          <Grid item lg={8} md={8} sm={12} xs={12}>
  <Grid container alignItems="flex-end" spacing={2} style={{ height: "100%" }}>
    {/* Tax Dropdown */}
    <Grid item lg={6} md={6} sm={6} xs={12}>
      <Typography variant="subtitle1">Tax</Typography>
      <TextField
        select
        size="small"
        fullWidth
        value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.tax}
        onChange={(e) => {
          const taxPercentage = Number(e.target.value);
          const productPrice =
            productRows[editIndex !== null ? editIndex : productRows.length - 1]?.price || 0;
          const taxAmount = productPrice * (taxPercentage / 100);

          handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "tax", taxPercentage);
          handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "taxAmount", taxAmount);
        }}
      >
        <MenuItem value={0}>No Tax</MenuItem>
        {taxList &&
          taxList.map((tax) => (
            <MenuItem key={tax.id} value={tax.percentage}>
              {tax.taxName} - {tax.percentage}%
            </MenuItem>
          ))}
      </TextField>
    </Grid>

    {/* Tax Amount */}
    <Grid
      item
      lg={6}
      md={6}
      sm={6}
      xs={12}
      style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}
    >
      {productRows[editIndex !== null ? editIndex : productRows.length - 1]?.tax > 0 && (
        <Typography
          variant="body2"
          style={{
            display: "flex",
            alignItems: "center", // Align content to the bottom
            padding:'10px',
          }}
        >
          Tax Amount: $
          {productRows[editIndex !== null ? editIndex : productRows.length - 1]?.taxAmount?.toFixed(2) || "0.00"}
        </Typography>
      )}
    </Grid>
  </Grid>
</Grid>



        </Grid>
        </DialogContent>
      <DialogActions sx={{ paddingRight: "24px", p: 4, py: 3, gap: 2 }}>
                <Grid container spacing={3}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={handleCancel}

                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                      variant="contained"
                      startIcon={<SaveAltIcon />}
                      className={classes.addButton}
                      onClick={() => {
                        if (editIndex !== null) {
                          // Edit product logic
                          const updatedRows = [...productRows];
                          updatedRows[editIndex] = productRows[editIndex];
                          setProductRows(updatedRows);
                          //console.log(updatedRows);
                        } else {
                          // Add new product logic
                          setProductRows([...productRows]);
                         // setProductRows([...productRows, productRows[productRows.length - 1]]);
                          //console.log([...productRows]);
                        }
                        setPopupOpen(false);
                      }}
                    >
               {editIndex !== null ? 'Update' : 'Save'}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>

    </Dialog>
     <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ borderBottom: 2, paddingBottom: 5 }}
                  className={classes.titleGrid}
                >

              <Grid container spacing={3}>
                <Grid item lg={8} md={8} sm={12} xs={12}>
                  <Grid container spacing={3} alignItems="center">
                    {discounts.map((discount, index) => (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={1}>
                         <Grid item lg={6} md={6} sm={6} xs={6}>
                            <TextField
                              placeholder="Description"
                              size="small"
                              value={discount.description}
                              onChange={(e) =>
                                handleDiscountChange(
                                  index,
                                  "description",
                                  e.target.value
                                )
                              }
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              className={classes.textField}
                            />
                          </Grid>
                           <Grid item lg={3} md={3} sm={3} xs={3}>
                            <TextField
                              placeholder="Discount"
                              size="small"
                              type="number"
                              value={discount.value}
                              onChange={(e) =>
                                handleDiscountChange(
                                  index,
                                  "value",
                                  Number(e.target.value)
                                )
                              }
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              className={classes.textField}
                            />
                          </Grid>
                         <Grid item lg={3} md={3} sm={3} xs={3} sx={{ display: "flex", gap: 1 }}>
                                                     <Grid item>
                                                       <IconButton
                                                         color="primary"
                                                         style={{ fontSize: 16 }}
                                                         onClick={() => handleOpenDialog(index)}
                                                       >
                                                         <FaEdit />
                                                       </IconButton>
                                                     </Grid>
                                                     <Grid item>
                                                       <IconButton
                                                         color="primary"
                                                         onClick={() => handleDeleteDiscount(index)}
                                                         style={{ fontSize: 16 }}
                                                       >
                                                         <FaTrash />
                                                       </IconButton>
                                                     </Grid>
                                                   </Grid>
                         
                        </Grid>
                      </Grid>
                    ))}
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      py={2}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        className={classes.addButton}
                        onClick={() => handleOpenDialog(null)} 
                      >
                        Discount
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <Grid container spacing={1}>
                   

<Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={6}
                          xs={6}
                          alignContent={"center"}
                          textAlign={"right"}
                        >
                          <Typography className={classes.h5}>
                            Sub Total :
                          </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <TextField
                            placeholder="Discount"
                            size="small"
                            value={subTotal.toFixed(2)}
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.textFieldQuote,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                   
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={6}
                          xs={6}
                          alignContent={"center"}
                          textAlign={"right"}
                        >
                          <Typography className={classes.h5}>
                            Total Discount :
                          </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <TextField
                            placeholder="Discount"
                            size="small"
                            value={totalDiscount.toFixed(2)}
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.textFieldQuote,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                      <Grid item lg={12} md={12} sm={12} xs={12}>
                                                                                  <Grid container spacing={1}>
                                                                                    <Grid
                                                                                      item
                                                                                      lg={6}
                                                                                      md={6}
                                                                                      sm={6}
                                                                                      xs={6}
                                                                                      alignContent={"center"}
                                                                                      textAlign={"right"}
                                                                                    >
                                                                                      <Typography className={classes.h5}>
                                                                                        HST
                                                                                      </Typography>
                                                                                    </Grid>
                                                                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                                                                      <TextField
                                                                                        placeholder="HST"
                                                                                        sx={{ width: "100%" }}
                                                                                        size="small"
                                                                                        value={taxAmount.toFixed(2)}
                                                                                        className={classes.textField}
                                                                                        InputProps={{
                                                                                          readOnly: true,
                                                                                          sx: {
                                                                                            fontSize: 14,
                                                                                          },
                                                                                          startAdornment: (
                                                                                            <InputAdornment position="start">
                                                                                              $
                                                                                            </InputAdornment>
                                                                                          ),
                                                                                          classes: {
                                                                                            root: classes.textFieldQuote,
                                                                                            notchedOutline: classes.notchedOutline,
                                                                                          },
                                                                                        }}
                                                                                        InputLabelProps={{
                                                                                          sx: {
                                                                                            fontSize: 14,
                                                                                          },
                                                                                        }}
                                                                                      />
                                                                                    </Grid>
                                                                                  </Grid>
                                                                                </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={6}
                          xs={6}
                          alignContent={"center"}
                          textAlign={"right"}
                        >
                          <Typography className={classes.h5}>
                            Grand Total :
                          </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <TextField
                            placeholder="Discount"
                            size="small"
                            value={(grandTotalEithDiscount ?? 0).toFixed(2)}
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.textFieldQuote,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container alignItems="center">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant="subtitle1">Remarks on invoice :                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Enter Remarks on invoice .."
                        size="small"
                        multiline
                        rows={8}
                        {...formik.getFieldProps("quoteWorkOrderCustomerRemark")}
                        className={classes.discriptionTextField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container alignItems="center">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant="subtitle1">Remarks on office use :</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Enter Remarks on office use .."
                        size="small"
                        multiline
                        rows={8}
                        {...formik.getFieldProps(
                          "quoteWorkOrderCustomerMemo"
                        )}
                        className={classes.discriptionTextField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={3}>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="contained"
                    startIcon={<SaveAltIcon />}
                    className={classes.addButton}
                    onClick={() => formik.handleSubmit()}
                    disabled={
                      !formValid || isLoading 
                    }
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            </Grid>

          <Dialog open={dialogOpen} onClose={handleCloseDialog}>
            <Grid className={classes.Dialog}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Set Discount
                  </Typography>
                </Grid>
              </Grid>
              <DialogContent>
                <Grid container spacing={3}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Discount :</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Invoice Number :"
                          size="small"
                          value={discountValue}
                          onChange={(e) =>
                            setDiscountValue(Number(e.target.value))
                          }
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                            startAdornment: (
                              <InputAdornment position="start">
                                $
                              </InputAdornment>
                            ),
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                          Description :
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Description .."
                          size="small"
                          multiline
                          rows={8}
                          value={discountDescription}
                          onChange={(e) =>
                            setDiscountDescription(e.target.value)
                          }
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions sx={{ paddingRight: "24px", p: 4, py: 3, gap: 2 }}>
                <Grid container spacing={3}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={handleCloseDialog}
                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                      variant="contained"
                      startIcon={<SaveAltIcon />}
                      className={classes.addButton}
                      onClick={handleSaveDiscount}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Grid>
          </Dialog>

          {openCompany && (
            <NewCompanyPopUp
              handleCloseDialog={() => setOpenCompany(false)}
              openModel={openCompany}
            />
          )}
        </form>
      </Card>
    </div>
  );
};

export default Index;
